import React from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import { Loading } from "@curves/ui-base";

import { getLoadingData } from "@Redux/loading/selector";

const ShowLoading = () => {
	const { count = 0 } = useSelector(getLoadingData);
	const isOpen = count > 0;

	// preventScroll：關閉時歸還焦點不觸發捲動，避免被拉回原本點擊的按鈕位置（如列表底部的分頁）
	return (
		<Modal isOpen={isOpen} overlayClassName="modal-overlay" className="modal-content" ariaHideApp={false} preventScroll onRequestClose={() => {}}>
			<Loading size={50} duration={700} />
		</Modal>
	);
};

export default ShowLoading;
